import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { matchPath, useLocation } from 'react-router-dom';
import { versionedRoutes } from '@sketch/constants';
import { IsEmbedded } from './IsEmbedded.js';
import { NotEmbedded } from './NotEmbedded.js';

/**
 * Embeddable routes whitelist.
 */
const embeddableRoutes = [
    versionedRoutes.SHARE_VIEW.LATEST,
    versionedRoutes.SHARE_VIEW.VERSION,
    versionedRoutes.SHARE_VIEW_GRID.LATEST,
    versionedRoutes.SHARE_VIEW_GRID.VERSION,
    versionedRoutes.ARTBOARD_DETAIL.LATEST,
    versionedRoutes.ARTBOARD_DETAIL.VERSION,
    versionedRoutes.ARTBOARD_REVISION.LATEST,
    versionedRoutes.ARTBOARD_REVISION.VERSION,
    versionedRoutes.ARTBOARD_DETAIL_UUID.LATEST,
    versionedRoutes.ARTBOARD_DETAIL_UUID.VERSION,
    versionedRoutes.SHARE_PAGE_VIEW.LATEST,
    versionedRoutes.SHARE_PAGE_VIEW.VERSION,
    versionedRoutes.SHARE_PAGE_CANVAS_VIEW.LATEST,
    versionedRoutes.SHARE_PAGE_CANVAS_VIEW.VERSION,
    versionedRoutes.PROTOTYPE.LATEST,
    versionedRoutes.PROTOTYPE.VERSION,
    versionedRoutes.PROTOTYPE_VIEW.LATEST,
    versionedRoutes.PROTOTYPE_VIEW.VERSION,
];
/**
 * Determines if the supplied pathname matches one of the whitelisted
 * embeddable routes.
 */
const isPathnameEmbeddable = (pathname) => Boolean(matchPath(pathname.replace(/^\/embed/, ''), {
    path: embeddableRoutes.map(route => route.template()),
    strict: false,
    exact: true,
}));
/**
 * If rendering while embedded, the EmbedGate only renders its children if the
 * initial pathname is strictly one of the whitelisted embedded routes listed
 * above, otherwise it outputs null. While rendering normally/un-embedded it's
 * a no-op and always renders children.
 */
const EmbedGate = props => {
    const location = useLocation();
    const embeddable = isPathnameEmbeddable(location.pathname);
    return (jsxs(Fragment, { children: [jsx(IsEmbedded, { children: embeddable ? props.children : null }), jsx(NotEmbedded, { children: props.children })] }));
};

export { EmbedGate };
